<style lang="scss">
.vsc-detail {
  overflow: hidden;
  margin-bottom: 15px;

  & > header {
    float: left;
    width: 80px;
    text-align: right;
    padding-right: 12px;
  }

  .vsc-content {
    padding: 12px;
    background-color: #f3f7f9;
    line-height: 32px;
    margin-left: 80px;
  }
}
</style>

<style lang="scss" scoped>
.vslist-detail {
  min-height: 20px;
  padding: 16px;
  margin-bottom: 20px;
  background-color: #f3f7f9;
  border: 1px solid #e4eaec;
  border-radius: 3px;
  width: 80%;
}
</style>

<template>
    <div class="lookitem">
        <Breadcrumb class="tablelist-header">
            <BreadcrumbItem>{{$t('erp.virtualstore.setallocation_warehouse',{defaultValue:'设定虚拟仓分配比例'})}}</BreadcrumbItem>
        </Breadcrumb>
        <Alert class="padding-10">
            <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
		</Alert>
        <Row class="bg-fff shadow padding-bottom-20">
            <Col span='24'>
            <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
            </Col>
            <Col span='12'>
            <span class="item-label">{{$t('global.common.name',{defaultValue:'名称'})}}：</span>
            <span class="item-content">{{formData.name}}</span>
            </Col>
            <Col span='12'>
            <span class="item-label">{{$t('global.common.project',{defaultValue:'项目'})}}：</span>
            <span class="item-content">{{formData.lineId|transferText('name',products)}}</span>
            </Col>
            <Col span='12'>
            <span class="item-label">ERPSKU：</span>
            <span class="item-content">{{formData.erpSku}}</span>
            </Col>
            <Col span='24'>
            <Form :label-width="100" ref="form">
                <section v-for="(item,index) in svRules" class="clearfix" :key="index">
                    <header class="item-label">{{item.stockGroupName}}</header>
                    <section class="item-content vslist-detail">
                        <div class="clearfix padding-top-5" v-for="data in item.orgWarehouseIds" :key="data.id">
                            <span class="width-80per pull-left">{{data.warehouseTitle}}({{data.warehouseCode}})</span>
                            <InputNumber class="pull-left " v-model="data.assignPercent"/>
                            %
                        </div>
                        {{$t('erp.virtualstore.setusestores',{defaultValue:'设定可用店铺'})}}:
                        <div style="margin-left:100px;">
                            <Transfer
                                :data="accountsTarget"
                                :target-keys="ruleAccounts[index]"
                                :list-style="listStyle"
                                filterable
                                :filter-method="filterMethod"
                                @on-change="(targetKeys)=>{handleStoreChange(targetKeys,index)}"></Transfer>
                        </div>
                    </section>
                </section>
            </Form>
            </Col>
            <Col span="24" class="text-center padding-10">
            <Button type="primary" class="width-15per" @click="routeBack">{{$t('erp.virtualstore.laststep',{defaultValue:'上一步'})}}</Button>
            <Button type="primary" class="width-15per" @click="submit">{{$t('erp.distribution.confirm_submit',{defaultValue:'提交'})}}</Button>
            <Button class="width-15per" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
            </Col>
        </Row>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import {
    HttpVsDetail, HttpSaveVs
} from '@/service/boss/allot';


export default {
    data() {
        return {
            loading: false,
            id: this.$route.query.id,
            type: this.$route.params.type,
            sourceData: this.$route.query.json,
            svRules: [],
            listStyle: {
                width: "39%",
                height: '300px',
            },
            // ruleItems: {},
            ruleAccounts: [],

            formData: {
                name: "",
                lineId: "",
                erpSku: "",
                description: "",
                productId: "",
                status: "",
            }
        }
    },
    created() {
        this.handleResponse(this.sourceData);
        // if (this.type !== 'set') {
        //     this.handleResponse(this.sourceData);
        // } else {
        //     // this.getDetail();
        // }

    },

    filters: {
        transferText(val, textKey, list = [], key = "id") {
            let text = "";
            list.forEach(item => {
                if (item[key] === val) {
                    text = item[textKey]
                }
            });
            return text;
        }
    },
    computed: {
        ...mapState('boss',['products', 'accounts']),
        ...mapGetters('boss',['warehouses']),
        accountsTarget() {
            return this.accounts.map((item) => {
                return {
                    label: `${item.title}(${item.flag})`,
                    key: item.id,
                }
            })
        },
    },
    methods: {
        routeBack(){
            this.$router.back(-1)
        },
        cancel() {
            this.$router.push({ name: "vstorelist" })
        },
        renderFormat(item) {
            return item.label + ' - ' + item.description;
        },
        handleStoreChange(targetKeys, index) {
            this.$set(this.ruleAccounts, index, targetKeys)
            // [index]=targetKeys;
        },
        handleResponse(data) {
            let { name, lineId, erpSku, description, status } = data;
            this.formData = { name, lineId, erpSku, description, status };
            this.svRules = (data.stockGroups || []).map((item, index) => {
				// console.log(item)
                let accountslist = data.rules.filter((items) => {
                    return items.stockGroupId == item;
                });
                if (accountslist.length > 0) {
                    accountslist = accountslist[0].stockVirtualGroupRuleAccountEntity;
                }
                let itemlist = data.organizationWarehouses || [];
                itemlist = itemlist.map((ware) => {
                    let warelist = data.rules.filter((rule) => {
                        return rule.stockGroupId == item;
                    });
                    if (warelist.length > 0) {
                        warelist = warelist[0].stockVirtualGroupRuleItemEntity;
                    }
                    const lastWare = warelist.filter((list) => {
                        return list.orgWarehouseId == ware;
                    });
                    if (lastWare.length == 0) {
                        const wareEntity = this.warehouses.filter((house) => {
                            return house.id == ware;
                        })[0];
                        return {
                            warehouseTitle: wareEntity.title,
                            warehouseCode: wareEntity.code,
                            orgWarehouseId: ware,
                            assignPercent: 0,
                            // id: item + '_' + wareEntity.id
                        }
                    } else {
                        return lastWare[0];
                    }
                });
                let rule = data.rules.filter((items) => {
                    return items.stockGroupId == item;
                })[0];
                if (!rule) {
                    rule={};
                    rule.stockGroupId = item;
                    if (item == 1) {
                        rule.stockGroupName = 'T1'
                    }
                    if (item == 2) {
                        rule.stockGroupName = 'T2'
                    }
                    if (item == 3) {
                        rule.stockGroupName = 'T3'
                    }
                    if (item == 4) {
                        rule.stockGroupName = 'T4'
                    }
                    if (item == 5) {
                        rule.stockGroupName = 'T5'
                    }
//                    rule.id = item;
                }

                rule.stockVirtualGroupRuleAccountEntity = accountslist;
                rule.orgWarehouseIds = itemlist;
                this.$set(this.ruleAccounts, index, rule.stockVirtualGroupRuleAccountEntity.map(json => {
                    return json.accountId;
                }));
                return rule;
            });
        },

        handleRequest(data) {
            data.stockVirtualGroupRules = this.svRules;
            const has = this.ruleAccounts.every(val => {
                return val.length > 0
            });
            if (!has) {
                this.$Message.warning(this.$t('global.common.choose',{defaultValue:'请选择'})+this.$t('global.common.channel',{defaultValue:'店铺'}));
                return false;
            }
            data.stockVirtualGroupRules.forEach((items, index) => {
                const accountIds = items.stockVirtualGroupRuleAccountEntity;
                items.accountIds = this.ruleAccounts[index].map((accountId) => {
                    let item = accountIds.find(function (value) {
                        return value.accountId == accountId
                    })
                    return item ? item : { accountId }
                });
                // console.log(items.accountIds)
            });
            data.orgId = global.SYSID;
            data.orgWarehouseIds = data.organizationWarehouses.join(',');
            return data;
        },
        async getDetail() {
            this.loading = true;
            HttpVsDetail({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.errorMessage(err.message);
                this.loading = false;
            });
        },
        async submit() {
            let sourceData = this.sourceData;
            // sourceData.rules = this.svRules;
			let data = this.handleRequest(sourceData);
            if(!data) return;
            this.loading = true;
            HttpSaveVs(data).then(res => {
                this.loading = false;
                this.$Message.success(res.message);
                this.$router.push({ name: "vstorelist" });
                sessionStorage.set('addListformData','')
            }, err => {
                this.errorMessage(err.message);
                this.loading = false;
            });
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
    }
}
</script>

